import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { MonthlyTargetsKpiCfg, MonthlyTargetsKpiCfgService } from "./monthlyTargetsKpiCfg.service";
import {
  KpiServiceError,
  KpiServiceErrorType,
} from "src/app/dashboardCommon/services/kpiServiceError";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class MonthlyGoalServiceData {
  public goals: string[];
  public updateTimestamp: Date;
}

@Injectable()
export class MonthlyTargetsService extends KpiService<MonthlyGoalServiceData> {
  public getClassName() {
    return "MonthlyTargetsService";
  }

  constructor(
    private serviceCfg: MonthlyTargetsKpiCfgService,
    private apigeeService: ApigeeService,
    private httpClient: HttpClient,
    injector: Injector
  ) {
    super(injector);
  }

  protected async update(): Promise<MonthlyGoalServiceData> {
    if (this.apigeeService.apiToken) {
      let result: MonthlyGoalServiceData = null;
      try {
        let cfg: MonthlyTargetsKpiCfg = this.serviceCfg.getCfg();
        let url = cfg.monthTargets.goalsEndPointPattern;
        result = await this.httpClient
          .get<MonthlyGoalServiceData>(url)
          .toPromise();
      } catch (error) {
        let errorMessage = error.error
          ? error.error.message || error.error.errorMessage
          : error.message;
        throw new KpiServiceError(
          KpiServiceErrorType.requestError,
          "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage)
        );
      }

      if (result == null)
        throw new KpiServiceError(
          KpiServiceErrorType.noData,
          "KpiServiceError-{0}-No data".format(this.getClassName())
        );
      else return result;
    } else {
      throw new KpiServiceError(
        KpiServiceErrorType.missingInputParameters,
        "KpiServiceError-{0}-Missing input parameters".format(
          this.getClassName()
        )
      );
    }
  }
}
